/**
 * External dependencies
 */
import React, { memo } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Image from '@naruto/naruto-components/src/base/v1/Image';
import useLayout from '@naruto/naruto-components/src/sxLayout';

/**
 * Internal dependencies
 */
import AllWrite from '@naruto/bgdapp/src/components/Common/AllWrite';
import { loadImage } from '@naruto/bgdapp/src/tools/image-loader';
import useData from './useData';
import SideItem from './SideItem';

function AppSideBar(): React.ReactElement {
  /* Global & Local State */
  const { general, mergedSx } = useLayout();
  const { mainRoutes, gotoHome, onChangeRoute } = useData();

  /* Main */
  return (
    <Box sx={{ ...mergedSx(general.FLEX_COLUMN, { p: 8, width: '100%', height: '100%' }) }}>
      <Box sx={{ width: '100%', height: 40, cursor: 'pointer' }} onClick={gotoHome}>
        <Image src={loadImage('logo.svg')} typeSize="fit" />
      </Box>
      <Box
        sx={{
          width: '100%',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          marginTop: 'clamp(80px, 22.23vh, 200px)'
        }}
      >
        <List component="nav">
          {mainRoutes.map(
            (route, index) =>
              route.showInSidebar && <SideItem key={index} item={route} parentRoute="" onChangeRoute={onChangeRoute} />
          )}
        </List>
      </Box>
      <Box
        sx={{
          width: '100%',
          height: '40px',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <AllWrite />
      </Box>
    </Box>
  );
}

export default memo(AppSideBar);
